import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { router } from '@/router';
import { queryClient } from '@/lib/queryClient';
import { i18n } from '@/lib/i18n';
import { ThemeProvider } from '@/lib/theme';
import { Toaster, ToastProvider } from '@/components/ui/toaster';
import { AuthProvider } from '@/features/auth/AuthProvider';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing from index.html');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider defaultTheme="dark" storageKey="fitfive-theme">
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ToastProvider>
              <RouterProvider router={router} future={{ v7_startTransition: true }} />
              <Toaster />
            </ToastProvider>
          </AuthProvider>
          {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
        </QueryClientProvider>
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>,
);
